"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ArrowRight = function ArrowRight(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 20 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 20 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#000" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    scale: width / 20,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.73214286,0.133928571 C9.8511907,0.0446428571 9.98511927,1.59872116e-14 10.1339286,1.59872116e-14 C10.2827379,1.59872116e-14 10.4017857,0.0446428571 10.4910714,0.133928571 L19.8214286,9.50892857 C19.9404764,9.59821429 20,9.71726213 20,9.86607143 C20,10.0148807 19.9404764,10.1339286 19.8214286,10.2232143 L10.4910714,19.5982143 C10.4017857,19.6875 10.2827379,19.7321429 10.1339286,19.7321429 C9.98511927,19.7321429 9.8511907,19.6875 9.73214286,19.5982143 L8.83928571,18.7053571 C8.75,18.6160714 8.70535714,18.4970236 8.70535714,18.3482143 C8.70535714,18.199405 8.75,18.0654764 8.83928571,17.9464286 L15.7589286,11.0267857 L0.535714286,11.0267857 C0.386904989,11.0267857 0.26041644,10.9747022 0.15625,10.8705357 C0.0520835604,10.7663693 0,10.6398807 0,10.4910714 L0,9.24107143 C0,9.09226213 0.0520835604,8.96577358 0.15625,8.86160714 C0.26041644,8.7574407 0.386904989,8.70535714 0.535714286,8.70535714 L15.7589286,8.70535714 L8.83928571,1.78571429 C8.75,1.66666644 8.70535714,1.53273787 8.70535714,1.38392857 C8.70535714,1.23511927 8.75,1.11607143 8.83928571,1.02678571 L9.73214286,0.133928571 Z",
    id: "arrowRight"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#arrowRight"
  }));
};

var _default = ArrowRight;
exports["default"] = _default;
module.exports = exports["default"];